import { LanguageCode } from './language-code.enum';

/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export const LocaleDateFormats: Partial<Record<LanguageCode, string>> = {
  [LanguageCode.nbNO]: 'dd.MM.yyyy',
  [LanguageCode.zhCN]: 'yyyy-MM-dd',
  [LanguageCode.zhHK]: 'yyyy-MM-dd',
  [LanguageCode.zhTW]: 'yyyy-MM-dd',
  [LanguageCode.csCZ]: 'dd. MM. yyyy',
  [LanguageCode.daDK]: 'dd.MM.yyyy',
  [LanguageCode.nlBE]: 'dd.MM.yyyy',
  [LanguageCode.nlNL]: 'dd-MM-yyyy',
  [LanguageCode.enAU]: 'dd/MM/yyyy',
  [LanguageCode.enCA]: 'yyyy-MM-dd',
  [LanguageCode.enGB]: 'dd/MM/yyyy',
  [LanguageCode.enUS]: 'MM/dd/yyyy',
  [LanguageCode.etEE]: 'dd.MM.yyyy',
  [LanguageCode.fiFI]: 'dd.MM.yyyy',
  [LanguageCode.frCA]: 'yyyy-MM-dd',
  [LanguageCode.frCH]: 'dd.MM.yyyy',
  [LanguageCode.frFR]: 'dd/MM/yyyy',
  [LanguageCode.frBE]: 'dd-MM-yyyy',
  [LanguageCode.deDE]: 'dd.MM.yyyy',
  [LanguageCode.deCH]: 'dd.MM.yyyy',
  [LanguageCode.elGR]: 'dd/MM/yyyy',
  [LanguageCode.huHU]: 'yyyy. MM. dd',
  [LanguageCode.itCH]: 'dd.MM.yyyy',
  [LanguageCode.itIT]: 'dd/MM/yyyy',
  [LanguageCode.idID]: 'dd/MM/yyyy',
  [LanguageCode.koKR]: 'yyyy.MM.dd',
  [LanguageCode.lvLV]: 'dd.MM.yyyy.',
  [LanguageCode.ltLT]: 'yyyy-MM-dd',
  [LanguageCode.plPL]: 'dd.MM.yyyy',
  [LanguageCode.ptPT]: 'dd/MM/yyyy',
  [LanguageCode.roRO]: 'dd.MM.yyyy',
  [LanguageCode.ruRU]: 'dd.MM.yyyy',
  [LanguageCode.skSK]: 'dd. MM. yyyy',
  [LanguageCode.esAR]: 'dd/MM/yyyy',
  [LanguageCode.esES]: 'dd/MM/yyyy',
  [LanguageCode.esMX]: 'dd/MM/yyyy',
  [LanguageCode.esCO]: 'dd/MM/yyyy',
  [LanguageCode.svSE]: 'yyyy-MM-dd',
  [LanguageCode.trTR]: 'dd.MM.yyyy',
  [LanguageCode.ukUA]: 'dd.MM.yyyy',
};

/* eslint-enable @typescript-eslint/no-duplicate-enum-values */
